// Builds a supplier statement from their supplier invoices: every bill in
// date order with what is still owed. KARIS records whether a supplier bill
// is paid (its status), not dated payment installments, so a paid bill
// simply owes nothing -- the statement never invents payment dates.
// Shared by the web Reports page and the mobile app (mobile/src/print/
// supplierStatement.js is a copy) so the two can never disagree.

const billDate = (b) => (b.created_at || b.due_date || "").toString().slice(0, 10);

export const isSettled = (b) => ["paid", "cancelled"].includes(String(b.status || "").toLowerCase());

export function buildSupplierStatement(bills) {
  const entries = bills
    .filter((b) => String(b.status || "").toLowerCase() !== "cancelled")
    .map((b) => ({
      key: b.id || b.invoice_no,
      date: billDate(b),
      invoice_no: b.invoice_no || "",
      due_date: (b.due_date || "").toString().slice(0, 10),
      status: b.status || "",
      amount: Number(b.amount) || 0,
      owed: isSettled(b) ? 0 : Number(b.amount) || 0,
    }))
    .sort((a, b) => a.date.localeCompare(b.date) || a.invoice_no.localeCompare(b.invoice_no));

  let balance = 0;
  entries.forEach((e) => { balance += e.owed; e.balance = balance; });

  const today = new Date().toISOString().slice(0, 10);
  const billed = entries.reduce((s, e) => s + e.amount, 0);
  const outstanding = entries.reduce((s, e) => s + e.owed, 0);
  const overdue = entries.filter((e) => e.owed > 0 && e.due_date && e.due_date < today).reduce((s, e) => s + e.owed, 0);
  return { entries, totals: { billed, paid: billed - outstanding, outstanding, overdue } };
}
